import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ dark }: { dark: boolean }) {
  const footerClass = dark
    ? "border-t border-slate-800 bg-slate-900/80 text-slate-400 text-sm"
    : "border-t border-slate-200/80 bg-white/80 text-slate-500 text-sm";

  return (
    <footer className={footerClass}>
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-3">
        <p>© 2025 MixMind – Projet en développement.</p>
        <div className="flex flex-wrap gap-4 text-xs">
          <Link to="/about" className="hover:text-slate-700">
            À propos
          </Link>
          <Link to="/contact" className="hover:text-slate-700">
            Contact
          </Link>
          <Link to="/confidentialite" className="hover:text-slate-700">
            Confidentialité
          </Link>
          <Link to="/mentions-legales" className="hover:text-slate-700">
            Mentions légales
          </Link>
          <Link to="/roadmap" className="hover:text-slate-700">
            Roadmap
          </Link>
        </div>
      </div>
    </footer>
  );
}
